import { connect } from 'react-redux';
import { updateFrequency } from '../../../actions/management/suggestedOrder';

import SuggestedOrderFopControlsView from '../../../components/management/suggestedOrder/SuggestedOrderFopControlsView';

export default connect(
  (state) => ({
    frequencyUpdatingSkus: state.ordersReserved.management.suggestedOrder.frequencyUpdatingSkus,
  }),
  { updateFrequency }
)(SuggestedOrderFopControlsView);
